// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".progress-ring__circle[data-v-3ec415f7]{-webkit-transition:stroke-dashoffset .75s;transition:stroke-dashoffset .75s;-webkit-transform:rotate(-90deg);transform:rotate(-90deg);-webkit-transform-origin:50% 50%;transform-origin:50% 50%;stroke-linecap:round;stroke:#460281}.progress-ring__circle.bg[data-v-3ec415f7]{stroke:#a293c7}.progress-ring__circle.shadow[data-v-3ec415f7]{stroke:#2c255e}", ""]);
// Exports
module.exports = exports;
